import BasePage from "@Scripts/Pages/BasePage";
import XtraVisualHelper from "@Scripts/Common/XtraVisualHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        super.setCarouselProducts();

        this.setInfotoast();
        this.setVisuals();
        this.setHighlights();
    }

    private static setInfotoast() {
        if ((<any>window).App.bag.isHome) {
            $(".infotoast").addClass("mrg").attr("data-mrgb", "0");
        }
    }

    private static setVisuals() {
        XtraVisualHelper.init();

        (<any>window).$(".visual-area").xtraVisual({
            timerInterval: 5000,
            isVisualLoaderEnabled: true,
            isSelectorEnabled: false,
            isTimerEnabled: true,
            isImageBackground: true,
            isSkinBackground: false,
            isSkinFullScreen: false,
            isGestureNavigation: true,
            isKeyboardNavigation: true
        });

        $(".ga-event[data-ga-id=\"VisualLink\"]").on("click", function () {
            GTagHelper.sendEvent("click", { home_visual: $(this).attr("href") });
        });
    }

    private static setHighlights() {
        (<any>$(".highlights")).masonry({
            columnWidth: ".grid-sizer",
            itemSelector: ".item",
            gutter: 0
        });

        $(".ga-event[data-ga-id=\"HighLightLink\"]").on("click", function () {
            GTagHelper.sendEvent("click", { home_highlight: $(this).attr("href") });
        });
    }
}